<template>
	<transition name="cartItem">
		<tr :class="isMiniCart ? 'cart-item border-bottom' : 'checkout-item'">
			<td>
				<img class="img-box-shadow" :src="cartItemData.ImageUrl" :alt="cartItemData.ProductName" v-if="cartItemData.ImageUrl">
			</td>
			<td colspan="2">
				<div :class="isMiniCart ? 'cart-item__info' : 'checkout-item__info'" >
					<a :href="getHrefValue" :class="isMiniCart ? 'type-h6 type-link no-underline' : 'type-h5 add-small-bottom-margin type-link no-underline'">{{ cartItemData.ProductName }}</a>
					<p :class="isMiniCart ? 'type-small' : ''">{{ cartItemData.Name }}</p>
					<div class="form-group flex flex--align-center" v-if="isMiniCart && !isDigitalProduct">
						<label for="item-quantity" class="sr">Quantity:</span></label>
						<div class="form-number-group flex">
							<button type="button" class="input-number-button" data-input="subtract" :class="{disabled : isDisabled}" @click="decreaseQuantity" v-if="cartItemData.Quantity > 1">-</button>
							<input type="number" name="item-quantity" min="1" class="input-number" :disabled="isDisabled" :class="{disabled : isDisabled}" v-model.lazy="cartItemData.Quantity" @keyup="handleQuantityChange">
							<button type="button" class="input-number-button" data-input="add" :class="{disabled : isDisabled}" @click="increaseQuantity">+</button>
						</div>
					</div>
          <p class="type-x-small color-soft-red type-bold add-top-margin" v-if="hasLowStock && isItemInStock">
            <span v-if="!isMiniCart">Going fast! </span>Only {{ getMaximumCartQuantity() }} left in stock.
          </p>
          <p class="type-x-small color-soft-red type-bold add-top-margin" v-if="!isItemInStock && isMiniCart">
            Out of stock
          </p>
          <div class="info-box info-box--error" v-if="!isItemInStock && !isMiniCart">
            <h4 class="info-box__title">Out of stock</h4>
            <p class="info-box__content">
              Unfortunately this product is now out of stock. Please remove the item from your cart before proceeding to checkout.
              <span v-if="cartItemData.EnableNotificationButton && !itemHasNotification">
                To be alerted when this product becomes available,
                <button
                  class="type-link"
                  type="button"
                  @click="addNotification">
                  sign up to be notified
                </button>.
              </span>
              <span v-if="cartItemData.EnableNotificationButton && itemHasNotification" class="fadeInSimple display-block">
                This item has been added to your notifications.
              </span>
            </p>
          </div>
					<div class="info-box" v-if="isDigitalProduct && !isMiniCart">
						<h4 class="info-box__title">{{ cartItemData.Name }}</h4>
						<p class="info-box__content">
              {{ cartItemData.Description }}
            </p>
					</div>
				</div>
			</td>
			<td>
				<div class="checkout-item__quantity">
					<span
					  :class="isMiniCart ? 'type-x-small type-bold btn__price--old' : 'type-bold btn__price--old'"
            v-if="cartItemData.ProductVariantPrice.PriceWithDiscount">{{ cartItemData.ProductVariantPrice.Price }}</span>
          <span
            :class="isMiniCart ? 'type-x-small type-bold' : 'type-bold'"
            v-if="cartItemData.ProductVariantPrice.PriceWithDiscount">{{ cartItemData.ProductVariantPrice.PriceWithDiscount }}</span>
          <span
					  :class="isMiniCart ? 'type-x-small type-bold' : 'type-bold'"
            v-if="!cartItemData.ProductVariantPrice.PriceWithDiscount">{{ cartItemData.ProductVariantPrice.Price }}</span>
					<div class="form-group flex flex--align-center" v-if="!isMiniCart && !isDigitalProduct">
						<label for="item-quantity" class="sr">Quantity:</span></label>
						<div class="form-number-group flex">
							<button type="button" class="input-number-button" data-input="subtract" :class="{disabled : isDisabled}" @click="decreaseQuantity" v-if="cartItemData.Quantity > 1">-</button>
							<input type="number" name="item-quantity" min="1" class="input-number" :class="{disabled : isDisabled}"  :disabled="isDisabled" v-model.lazy="cartItemData.Quantity" @keyup="handleQuantityChange">
							<button type="button" class="input-number-button" data-input="add" :class="{disabled : isDisabled}" @click="increaseQuantity">+</button>
						</div>
					</div>
					<button
						type="button"
						class="type-link type-x-small no-side-padding"
						@click="deleteItem"
						v-text="isMiniCart ? 'Remove' : 'Remove From Cart'"></button>
				</div>
			</td>
		</tr>
	</transition>
</template>

<script>
import {
  UPDATE_CART_QUANTITY,
  DELETE_CART_ITEM,
  FETCH_REFRESHED_CART_DATA,
  UPDATE_ITEM_LOADED_COUNT,
  UPDATE_AFTER_ADD_OR_DELETE,
  ADD_ITEM_NOTIFICATION,
  FETCH_ITEM_NOTIFICATIONS,
} from '../vuex/modules/cart/mutations';
import _ from 'lodash';

import { mapActions, mapState } from 'vuex';

export default {
	name: 'CartItem',
	props: ['cartItemData', 'isMiniCart'],
  data() {
		return {
			Id: null,
			ProductId: null,
			ItemQuantity: null,
			ProductVariantId: null,
      ImageUrl: null,
      HasNotification: false,
		}
	},
	mounted() {
    this.setInitialState();

		if( this.isMiniCart  ) {
			this.$store.commit(UPDATE_ITEM_LOADED_COUNT);
    }
	},

	methods: {
		...mapActions({
			UPDATE_CART_QUANTITY,
			DELETE_CART_ITEM,
			FETCH_REFRESHED_CART_DATA,
			UPDATE_ITEM_LOADED_COUNT,
      UPDATE_AFTER_ADD_OR_DELETE,
      ADD_ITEM_NOTIFICATION,
      FETCH_ITEM_NOTIFICATIONS,
		}),

		// only this method should trigger the updateTotal
		// method. Other methods should call this one
		// in order to fire the
		// UPDATE_CART_QUANTITY action.
		handleQuantityChange($event) {
			if( $event ) {
        const value = $event.target.value;
				this.ItemQuantity = parseInt(value);
      }
        this.updateTotal();
		},

		setInitialState() {
			this.Id = this.cartItemData.Id;
			this.ProductId = this.cartItemData.ProductId;
			this.ItemQuantity = this.cartItemData.Quantity;
			this.ProductVariantId = this.cartItemData.ProductVariantId;
			this.Price = this.cartItemData.ProductVariantPrice.Price;
			this.Name = this.cartItemData.Name;
			this.ImageUrl = this.cartItemData.ImageUrl;
		},

		increaseQuantity: _.debounce(function() {
      if (!this.isItemInStock) return false;

      // console.log(this.ItemQuantity);
      const nextVal = this.ItemQuantity + 1;
      // console.log(nextVal);
      const isWithinStockLimit = this.checkStockLimit(nextVal);

      if( isWithinStockLimit ){
        this.ItemQuantity += 1;
        this.handleQuantityChange();
      }else{
        this.throwLimitError()
      }

		}, 100),

		decreaseQuantity: _.debounce(function($event) {
      if (!this.isItemInStock) return false;
      // console.log($event);
			if( this.ItemQuantity - 1 <= 0 ){
			  this.deleteItem();
			}else{
				this.ItemQuantity -= 1;
				this.handleQuantityChange();
			}
		}, 100),

		deleteItem() {
			const $vm = this;
			if( window.confirm('This will remove the item from the cart. Are you sure?') ){
				this.DELETE_CART_ITEM( this.Id )
					.then( function(){
						// console.log('deleted cart item');
						$vm.UPDATE_AFTER_ADD_OR_DELETE();
					});
			}
		},

		updateTotal() {
			const $vm = this;
			this.UPDATE_CART_QUANTITY( { itemId: this.Id, quantity: this.ItemQuantity} )
				.then( function() {
					// console.log('promise returned, now refresh cart data');
					$vm.FETCH_REFRESHED_CART_DATA();
				});
    },



    // a variation of this method exists on the AddToCart component as well.
    // make sure to change it if this needs editing.
    throwLimitError() {
      const limit = this.getMaximumCartQuantity();
      alert(`Sorry, we only have ${limit} unit(s) available at this time.`);
    },



    // a variation of this method exists on the AddToCart component as well.
    // make sure to change it if this needs editing.
    checkStockLimit(value) {
      const availableStock = this.getMaximumCartQuantity();
      const isInventoryManaged = this.cartItemData.ManageInventoryMethodId;
      const isUk = window.env.ACTIVE_DOMAIN == 'domain_uk' ? true : false;

      // this means it's either print on demand or digital,
      // since they don't manage that inventory
      // OR it's the uk and they don't care whether it's out of stock
      if( isInventoryManaged == 0 || isUk ) {
        return true;
      }

      return value > availableStock ? false : true;
    },

    addNotification() {
      this.ADD_ITEM_NOTIFICATION( this.cartItemData.ProductVariantId )
        .then( () => {
          this.FETCH_ITEM_NOTIFICATIONS()
        })
    },


    // a variation of this method exists on the AddToCart component as well.
    // make sure to change it if this needs editing.
    getMaximumCartQuantity() {
      const available = this.cartItemData.StockQuantity;
      const minimumStock = this.cartItemData.MinimumStockQuantity;

      return available - minimumStock;
    },

	},

	computed: {
		...mapState({
			Items: state => state.cartStore.Items,
      allProductsLoaded: state => state.cartStore.allProductsLoaded,
      Notifications: state => state.cartStore.Notifications,
    }),

		getHrefValue(){
			return `${window.env.APP_URL}s/${this.cartItemData.ProductId}/`;
    },

    isDigitalProduct() {
      return this.cartItemData.IsDownloadble ? true :
                           this.cartItemData.ViewableOnly ? true :
                           this.cartItemData.PrintableOnly ? true :
                           false;
    },

    isItemInStock() {
      const quantity = this.cartItemData.Quantity;
      const isWithinStockLimit = this.checkStockLimit(quantity);

      return isWithinStockLimit ? true : false;
    },


    // a variation of this method exists on the AddToCart component as well.
    // make sure to change it if this needs editing.
    hasLowStock() {
      const availableStock = this.cartItemData.StockQuantity;
      const isInventoryManaged = this.cartItemData.ManageInventoryMethodId;
      const isUk = window.env.ACTIVE_DOMAIN == 'domain_uk' ? true : false;

      // this means it's either print on demand or digital,
      // since they don't manage that inventory
      // OR it's the uk and they don't care whether it's out of stock
      if( isInventoryManaged == 0 || isUk ) {
        return false;
      }

      return availableStock <= 5 ? true : false;
    },

    itemHasNotification() {
      return this.Notifications.some( item => {
        return item.ProductVariantId == this.cartItemData.ProductVariantId;
      })
    },

    isDisabled() {
      return !this.isItemInStock;
    }
	}
}

</script>



// WEBPACK FOOTER //
// resources/assets/js/components/CartItem.vue